export const RWD_PLACEMENT_AFTER = "after" as RwdPlacementType;
export const RWD_PLACEMENT_BEFORE = "before" as RwdPlacementType;
export const RWD_PLACEMENT_PREPEND = "prepend" as RwdPlacementType;
export const RWD_PLACEMENT_APPEND = "append" as RwdPlacementType;

export declare type RwdPlacementType = "after" | "before" | "prepend" | "append";
